const KEY = "gillspotter-observer";

/** The observer's name from last time, so they only type it once. */
export function recallObserver(): string {
  try {
    return localStorage.getItem(KEY) ?? localStorage.getItem("firmament-observer") ?? "";
  } catch {
    return "";
  }
}

export function rememberObserver(name: string): void {
  try {
    localStorage.setItem(KEY, name);
  } catch {
    // Storage disabled (private mode): the name is simply asked for again next time.
  }
}
